import React from 'react'
import '../../css/aboutUs/showroom.css'

export default function Showroom() {
    return (
        <div className="showroom" style={{overflow:"hidden"}}>
            <h1 data-aos="zoom-in">SHOWROOM</h1>
            <img src="assets/about/showroom.png" alt="" data-aos="fade-right" />
            <p data-aos="fade-left">After years of exporting various Home Textiles items, Today we have a splendid collection of fabrics and made ups for entire home in wide range of design. All our collections are beautifully showcased for buyers in an ambient showroom.Our Show Room is a well equipped work place for buyers with all communication facilities. Buyers are assisted by seasoned merchandisers and technicians to create & source new designs in short notice.</p>
        </div>
    )
}
